import {City} from '@/models/City'
import {DataProductTopArray} from '@/models/Product'
import {CustomerAddress, DataCustomerAddressesArray} from './CustomerAddress'
import {District} from '@/models/District'
import {Model} from '@/models/Model'
import {DataOrdersArray, Order} from '@/models/Order'
import {OrderUser} from '@/models/OrderUser'
import {Province} from '@/models/Province'
import {DataArray, DataResource, FilterSet} from '@/models/Response'
import Helper from '../services/Helper.js'


export const CustomerConst = Object.freeze({
  STATUS_SUBMITTED_PENDING_SYNC: 4,
  STATUS_SYNCED_PENDING_ACTIVE: 5,
  STATUS_ACCOUNT_CONFIRMED_WAIT_DO: 6,
  STATUS_REJECTED: 50,
  STATUS_NOT_USE: 99,

  GIS_TYPE_NONE: 0,
  GIS_TYPE_DISTRICT: 1,
  GIS_TYPE_GOOGLE: 2,
  GIS_TYPE_USER: 3,


  map(status: number): string {
    switch (status) {
      case CustomerConst.STATUS_SUBMITTED_PENDING_SYNC:
        return 'รอยืนยัน'
      case CustomerConst.STATUS_SYNCED_PENDING_ACTIVE:
        return 'รอยืนยัน'
      case CustomerConst.STATUS_ACCOUNT_CONFIRMED_WAIT_DO:
        return 'ปกติ'
      case CustomerConst.STATUS_REJECTED:
        return 'ไม่อนุมัติ'
      case CustomerConst.STATUS_NOT_USE:
        return 'ไม่ใช้แล้ว'
    }
    // debugger
    return 'ไม่ระบุ'
  },

})


export class Customer extends Model {
  declare id: number
  created_at: Date | null
  updated_at: Date | null
  name: string | null = ''
  nickname: string | null
  short_name: string | null
  address: string | null = ''
  district: string | null | any
  district_id: number | null
  district_obj: District | null
  city: string | null
  city_id: number | null
  city_obj: City | null
  province: string | null
  province_id: number | null
  province_obj: Province | null
  zip_code: string | null = ''
  code: string | null
  erp_contract: string | null
  erp_tel: string | null
  erp_email: string | null
  erp_remark1: string | null
  erp_remark2: string | null
  erp_remark3: string | null
  erp_remark4: string | null
  contracts: any | null
  business_type: string | null
  price_group: any | null
  credit_term: number | null
  credit_amount: number | null
  debit_amount: number = 0
  debit_overdue: number = 0
  debit_invoice: number = 0
  debit_pending: number = 0
  last_sync_at: string | null
  last_order_amount: number | null
  last_order_at: string | null
  gis_lat: number | null
  gis_lng: number | null

  gis_type: number | null

  cache_sales: any | null
  business_hour: any | null
  custom: any | null
  orders: Order[] | []
  mode: string | null

  type: string | null
  status: number | null
  tax_no: string | null

  ship_to

  stars: { id }[]

  sales: OrderUser[] | null

  shipping_addresses: CustomerAddress[] | null = []

  cache_lat: number | null
  cache_lng: number | null

  gis_is_confirm: boolean | null

  vat_type: number | null

  getResourceURL(): string {
    return Helper.setting.customer.getResourceAPI
  }


  async search_location(id): Promise<Customer> {
    return await new Promise<Customer>((resolve, reject) => {
      Helper.put(this.getResourceURL()
        .replace('{id}', id + '/search_location'), {})
        .then<{ data: DataResource }>(({data}) => resolve(data.data))
        .catch((e) => reject(e))
    })
  }

  async save_location(customer: Customer): Promise<Customer> {
    return await new Promise<Customer>((resolve, reject) => {
      Helper.put(this.getResourceURL()
        .replace('{id}', customer.id + '/save_location'), {
        lat: customer.cache_lat,
        lng: customer.cache_lng,
      })
        .then<{ data: DataResource }>(({data}) => resolve(data.data))
        .catch((e) => reject(e))
    })
  }

  async confirm_location(customer: Customer): Promise<Customer> {
    return await new Promise<Customer>((resolve, reject) => {
      Helper.put(this.getResourceURL()
        .replace('{id}', customer.id + '/confirm_location'), {
        gis_is_confirm: customer.gis_is_confirm,
      })
        .then<{ data: DataResource }>(({data}) => resolve(data.data))
        .catch((e) => reject(e))
    })
  }


  async SetStar(is_star: boolean): Promise<boolean> {
    return await new Promise<boolean>((resolve, reject) => {
      Helper.put(this.getResourceURL()
        .replace('{id}', this.id.toString() + '/toggle_star'), {star: is_star})
        .then<{ data: DataResource }>(({data}) => resolve(data.data.star))
        .catch((e) => reject(e))
    })
  }

  public async loadOrders(): Promise<DataOrdersArray> {
    console.log('Customer load order')
    return await new Promise<DataOrdersArray>((resolve, reject) => {
      Helper.get(Helper.setting.customer.getOrderAPI.replace('{id}', this.id))
        .then<{ data: DataOrdersArray }>(({data}) => resolve(data))
        .catch((e) => reject(e))
    })
  }
  public async loadProducts(): Promise<DataProductTopArray> {
    console.log('Customer load product')
    return await new Promise<DataProductTopArray>((resolve, reject) => {
      Helper.get(Helper.setting.customer.getProductsAPI.replace('{id}', this.id))
          .then<{ data: DataProductTopArray }>(({data}) => resolve(data))
          .catch((e) => reject(e))
    })
  }

  public async loadAddresses(): Promise<DataCustomerAddressesArray> {
    console.log('Customer load order')
    return await new Promise<DataCustomerAddressesArray>((resolve, reject) => {
      Helper.get(Helper.setting.customer.getAddressAPI.replace('{id}', this.id))
        .then<{ data: DataCustomerAddressesArray }>(({data}) => resolve(data))
        .catch((e) => reject(e))
    })
  }


  public async loadStat(): Promise<any> {
    console.log('Customer load stat')
    return await new Promise<any>((resolve, reject) => {
      Helper.get(Helper.setting.customer.getStatAPI.replace('{id}', this.id))
        .then<{ data: any }>(({data}) => resolve(data))
        .catch((e) => reject(e))
    })
  }
}

export class DataCustomersArray extends DataArray {

  declare data: Customer[]
  filter: FilterCustomer = new FilterCustomer()
}


export class FilterCustomer {

  type: FilterSet = new FilterSet()
  province: FilterSet = new FilterSet()
}


export class DataCustomer extends DataResource {

  declare data: Customer

}
